import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPpt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 128,
	height: 128,
	xmlns: "http://www.w3.org/2000/svg",
	"aria-label": "PPT file icon",
	role: "img",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("title", { children: "Layer 1" }),
		/* @__PURE__ */ _jsx("path", {
			id: "svg_1",
			opacity: 0,
			fill: "currentColor",
			d: "m28,14l52,0l20,20l0,80a10,10 0 0 1 -10,10l-62,0a10,10 0 0 1 -10,-10l0,-90a10,10 0 0 1 10,-10z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "svg_2",
			strokeLinejoin: "round",
			strokeWidth: 6,
			stroke: "currentColor",
			d: "m28,14l52,0l20,20l0,80a10,10 0 0 1 -10,10l-62,0a10,10 0 0 1 -10,-10l0,-90a10,10 0 0 1 10,-10z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "svg_3",
			opacity: 0,
			fill: "currentColor",
			d: "m80,14l0,20l20,0"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "svg_4",
			strokeLinejoin: "round",
			strokeWidth: 6,
			stroke: "currentColor",
			d: "m80,14l0,20l20,0"
		}),
		/* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			textAnchor: "start",
			fontFamily: "'Azeret Mono'",
			fontSize: 34,
			id: "svg_5",
			y: 104,
			x: 30,
			strokeWidth: 0,
			stroke: "#000",
			fill: "#000000",
			children: "PPT"
		})
	] })
});
export default SvgPpt;
